"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StableCoinProxyAdmin__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "changeProxyAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
        ],
        name: "getProxyImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ITransparentUpgradeableProxy",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class StableCoinProxyAdmin__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(initialOwner, overrides) {
        return super.deploy(initialOwner, overrides || {});
    }
    getDeployTransaction(initialOwner, overrides) {
        return super.getDeployTransaction(initialOwner, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.StableCoinProxyAdmin__factory = StableCoinProxyAdmin__factory;
StableCoinProxyAdmin__factory.bytecode = _bytecode;
StableCoinProxyAdmin__factory.abi = _abi;
